var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/arrow-right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.66958 19.4909C8.49542 19.4909 8.32125 19.4267 8.18375 19.2892C7.91792 19.0234 7.91792 18.5834 8.18375 18.3175L14.1604 12.3409C14.6004 11.9009 14.6004 11.1859 14.1604 10.7459L8.18375 4.76919C7.91792 4.50335 7.91792 4.06335 8.18375 3.79752C8.44958 3.53169 8.88958 3.53169 9.15542 3.79752L15.1321 9.77419C15.5996 10.2417 15.8654 10.8742 15.8654 11.5434C15.8654 12.2125 15.6088 12.845 15.1321 13.3125L9.15542 19.2892C9.01792 19.4175 8.84375 19.4909 8.66958 19.4909Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArWhite);
export default __webpack_public_path__ + "static/media/ar_white.4a79edd1d8077d89bb0e3aadf129b79f.svg";
export { ForwardRef as ReactComponent };